"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var general_exports = {};
__export(general_exports, {
  General: () => General
});
module.exports = __toCommonJS(general_exports);
var General;
((General2) => {
  let AppData;
  ((AppData2) => {
    AppData2.path = "general/appData";
  })(AppData = General2.AppData || (General2.AppData = {}));
  let Countries;
  ((Countries2) => {
    Countries2.path = "general/countries";
  })(Countries = General2.Countries || (General2.Countries = {}));
  let Notify;
  ((Notify2) => {
    Notify2.path = "notify";
  })(Notify = General2.Notify || (General2.Notify = {}));
})(General || (General = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  General
});
